import Icon from '../Icon/Icon';
import './SocialMedia.scss';

import {
  SocialActionEnum,
  useControllerSocialMediaContext
} from '../../hooks/ControllerSocialMedia';

import { useGoogleLogin } from '@react-oauth/google';
import Button from '../Button/Button';
import { setCookie } from '../../services/cookieController';
import { useAuthContext } from '../../hooks/AuthContext';
import {
  handleOAuthRedirectURI,
  isSocialRecoveryFlow,
  pushGtmEvent,
  saveSocialFlowPath
} from '../../utils/GenericFunctions';

interface ButtonGoogleProps {
  action?: SocialActionEnum;
  showText?: boolean;
}

export default function ButtonGoogle({
  action,
  showText = false
}: ButtonGoogleProps) {
  const { googleHandleCredentialResponse } = useControllerSocialMediaContext();

  const { redirectURL } = useAuthContext();

  const login = useGoogleLogin({
    flow: 'auth-code',
    ux_mode: 'redirect',
    redirect_uri: handleOAuthRedirectURI('google', action),
    scope:
      'email profile https://www.googleapis.com/auth/user.birthday.read https://www.googleapis.com/auth/user.phonenumbers.read',
    include_granted_scopes: true,
    onSuccess: (codeResponse) =>
      googleHandleCredentialResponse(codeResponse?.code, action),
    onError: (error) => console.error('Google Login Error:', error)
  });

  return (
    <Button
      customColors="btn-neutral"
      id="google-btn"
      data-testid="btn-google"
      aria-label="Entrar com Apple"
      className="social-medias__google"
      onClick={() => {
        if (isSocialRecoveryFlow()) {
          pushGtmEvent('recovery_social_click', { provider: 'google' });
        }
        if (redirectURL) setCookie('redirect', redirectURL);
        saveSocialFlowPath();
        login();
      }}
    >
      <Icon name="logoGoogle" />
      {showText && 'Continuar com Google'}
    </Button>
  );
}
